import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
//import FormLabel from '@mui/material/FormLabel';
import StocksContext from '../../../contexts/StocksContext';
import StatusContext from '../../../contexts/StatusContext'


export const RadioButtonsPrice = () => {

  const {
    changeLanguageEnglish,
} = React.useContext(StatusContext);

 const {
    historicalDataLength,
    setHistoricalDataLength,
} = React.useContext(StocksContext);


  const handleChange = (event) => {
    setHistoricalDataLength(event.target.value)
  };

  return (
    <FormControl >
     
      {/*<FormLabel id="demo-controlled-radio-buttons-group">{changeLanguage('status', 'responsetype')}:</FormLabel>*/}
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={historicalDataLength}
        onChange={handleChange}
      >

         <FormControlLabel  sx={{
                      '& .MuiSvgIcon-root': {
                      fontSize: 14,
                      }, }}
                      value="1"  control={<Radio size ="small"/>} label={changeLanguageEnglish('stocks', 'price5days')} />

        <FormControlLabel  sx={{
                      '& .MuiSvgIcon-root': {
                      fontSize: 14,
                      }, }}
                      value="2"  control={<Radio size ="small"/>} label={changeLanguageEnglish('stocks', 'price10days')} />

        <FormControlLabel sx={{
                      '& .MuiSvgIcon-root': {
                      fontSize: 14,
                      }, }}
                      value="3" control={<Radio size ="small"/>} label={changeLanguageEnglish('stocks', 'price15days')} />

        <FormControlLabel sx={{
                      '& .MuiSvgIcon-root': {
                      fontSize: 14,
                      }, }}
                      value="4" control={<Radio size ="small"/>} label={changeLanguageEnglish('stocks', 'price1month')} />
      
      
      </RadioGroup>
     
    </FormControl>
  );
}

export default RadioButtonsPrice
